module.exports = __webpack_public_path__ + "img/pointA_bg.219fa0d1.png";